module.exports = __webpack_public_path__ + "img/yijiao.b4e87477.svg";